import React from 'react'

import { VStack } from '~/components/elements/VStack'

import { useAvailableCustomerAttributeGroups } from '../hooks/useAvailableCustomerAttributeGroups'

import { CustomerAttributeGroupCheckboxTree } from './CustomerAttributeGroupCheckboxTree'

export const CustomerAttributeGroupCheckboxTreeList = () => {
  const customerAttributeGroups = useAvailableCustomerAttributeGroups()

  return (
    <VStack spacing={4}>
      {customerAttributeGroups.map((customerAttributeGroup) => (
        <CustomerAttributeGroupCheckboxTree
          key={customerAttributeGroup.id}
          customerAttributeGroup={customerAttributeGroup}
        />
      ))}
    </VStack>
  )
}
